(() => {
  const initGallery = (root = document) => {
    root.querySelectorAll('[data-ff-product-page] [data-ff-gallery]').forEach((gallery) => {
      if (gallery.dataset.vrstyGalleryReady === 'true') return;

      const mainImage = gallery.querySelector('[data-ff-gallery-main]');
      const thumbnails = gallery.querySelectorAll('[data-ff-gallery-thumb]');
      if (!mainImage || !thumbnails.length) return;

      gallery.dataset.vrstyGalleryReady = 'true';
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const thumbnailImage = thumbnail.querySelector('img');
          const nextSource = thumbnail.dataset.ffGallerySrc || thumbnailImage?.currentSrc || thumbnailImage?.src;
          if (!nextSource) return;

          mainImage.removeAttribute('srcset');
          mainImage.src = nextSource;
          if (thumbnailImage?.alt) mainImage.alt = thumbnailImage.alt;

          thumbnails.forEach((item) => {
            const isActive = item === thumbnail;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', String(isActive));
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGallery(), { once: true });
  } else {
    initGallery();
  }

  document.addEventListener('shopify:section:load', (event) => initGallery(event.target));
})();
